module.exports = __webpack_public_path__ + "static/NanumSquareB-e850eb664f41c0828a8aac6f1d09b643.ttf";